import { getChampionshipAnnouncedTeams } from 'modules/teams/store/championship-teams/actions';
import {
  announcedChampionshipTeamsDataSelector,
  announcedChampionshipTeamsIsLoadingSelector,
  championshipTeamsChampionshipIdSelector,
} from 'modules/teams/store/championship-teams/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import ChampionshipTeamPlayers from '../components/championship-team-players/championship-team-players';

const isNullOrUndefined = (value: any) => value === null || value === undefined;

const TeamPlayersPage = () => {
  const { id, teamId } = useParams();
  const championshipIdInt = isNullOrUndefined(id) ? null : parseInt(id!);
  const teamIdInt = isNullOrUndefined(teamId) ? null : parseInt(teamId!);

  const currentChampionshipId = useSelector(championshipTeamsChampionshipIdSelector);
  const isLoading = useSelector(announcedChampionshipTeamsIsLoadingSelector);
  const announcedTeams = useSelector(announcedChampionshipTeamsDataSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!championshipIdInt) {
      return;
    }

    if (!isLoading && (currentChampionshipId !== championshipIdInt || !announcedTeams)) {
      dispatch(getChampionshipAnnouncedTeams({ championshipId: championshipIdInt }));
    }
  }, [championshipIdInt, isLoading, announcedTeams, currentChampionshipId, dispatch]);

  if (championshipIdInt === null || teamIdInt === null) {
    return null;
  }

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col">
      <ChampionshipTeamPlayers teamId={teamIdInt} championshipId={championshipIdInt} />
    </div>
  );
};

export default TeamPlayersPage;
